import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OriginalRouteService {
  private originalName: string = '';

  setOriginalName(name: string): void {
    this.originalName = name;
  }

  getOriginalName(): string {
    return this.originalName;
  }
}
